module.exports = __webpack_public_path__ + "img/footer.e0d32bf6.jpg";